<template>
  <div :class="{ 'invalid': !isValid, 'valid': isValid}">
    <label :for="name">{{label}}</label>
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <div class="custom-radio" :class="{ 'detailed': isDetail}">
      <div class="container">
        <p>Administrator</p>
        <input 
          type="radio" 
          autocomplete="off"
          name="role"
          :disabled="isDisabled"
          :checked="this.isAdmin ? 'checked' : ''" 
          @input="$emit('input', 'admin')"
        >
        <input type="radio" autocomplete="off" name="role">
        <span class="checkmark"></span>
      </div>
      <div class="container">
        <p>Operator</p>
        <input 
          autocomplete="off"
          type="radio" 
          :checked="this.isAdmin ? '' : 'checked'" 
          name="role"
          :disabled="isDisabled"
          @input="$emit('input', 'employee')"
        >
        <span class="checkmark"></span>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
    computed : {},
    props: {
      label: String,
      name: String,
      value: String,
      isTextArea: Boolean,
      isDisabled: Boolean,
      placeholder: String,
      isDetail: Boolean,
      isAdmin: Boolean
    },
    data() {
      return {
        isValid: true,
        errorDescription: 'Test can not be empty'
      }
    }
	}
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/radio";

.custom-radio {
  margin-bottom: 15px;
}

.container {
  height: 18px;
  margin-bottom: 0px;

  p {
    font-size: 12px;
    padding-top: 3px;
    margin-right: 16px;
  }
}

</style>
